export function LoginVideo({
  className,
  ...props
}: React.ComponentProps<'video'>): React.ReactNode {
  return (
    <video autoPlay muted loop playsInline className={className} {...props}>
      <source src="/videos/coolmate-login-v1.mp4" type="video/mp4" />
    </video>
  );
}
